import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { User } from '../entities/user';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment.development';
import { Observable, catchError, of, throwError } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

interface ApiResponse {
  status: string;
  data: User | User[];
}

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) {  }

  private apiServicesUrl = environment.cfgApiBaseUrl;
  private userServiceUrl = this.apiServicesUrl + '/user';

  getUser(userName: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.userServiceUrl + '/' + userName)
    .pipe(
      catchError(this.handleError<ApiResponse>('getUsers'))
    );
  }

  checkUser(userName: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.userServiceUrl + '-exists/' + userName)
    .pipe(
      catchError(this.handleError<ApiResponse>('getUsers'))
    );
  }

  saveUser(user: User): Observable<ApiResponse> {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }
    return this.http.post<ApiResponse>(this.userServiceUrl, user, httpHeaders)
    .pipe(
      catchError(this.handleError<ApiResponse>('getUsers'))
    );
  }

  changePassword(userName: string, password: string):Observable<ApiResponse> {
    let token;
    if (isPlatformBrowser(this.platformId))
      token = sessionStorage.getItem('auth');
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'bearer ' + token
      })
    }
    return this.http.put<ApiResponse>(this.userServiceUrl + '-password', {'userName': userName, 'password': password}, httpHeaders)
    .pipe(
      catchError(err => { return throwError(() => err) })
    );
  }

  changeUsername(oldUserName: string, newUserName: string, urlId: string):Observable<ApiResponse> {
    let token;
    if (isPlatformBrowser(this.platformId))
      token = sessionStorage.getItem('auth');
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'bearer ' + token
      })
    }
    return this.http.put<ApiResponse>(this.userServiceUrl + '-username', {'oldUserName': oldUserName, 'newUserName': newUserName, 'urlId': urlId}, httpHeaders)
    .pipe(
      catchError(err => { return throwError(() => err) })
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
